<template>
  <div>
    <div class="col-12 px-0">
      <div class="d-flex align-items-center justify-content-between mb-0">
        <div>
          <h5 class="font-weight-bold">
            Tipos de Compromissos (Agenda Ativa)
          </h5>
        </div>

        <div>
          <div class="input-group mb-3">
            <b-input
              :placeholder="$t('Type to search')"
              class="form-control search-input"
              type="search"
              v-model="search"
              v-on:change="getListTiposCompromissos"
              aria-describedby="input-search"
            />
            <div class="input-group-append" role="button">
							<span class="input-group-text" id="input-search"
              ><i class="fas fa-search search-icon"
              /></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form @submit.prevent="inserirTipoCompromisso">
      <div class="row">
        <form-input
          :required="true"
          v-model="descricao"
          label="Descrição"
          grid="5"
        />
        <div class="col-5 d-flex align-items-center">
          <div class="float-left mr-2">
            <toggle-button
              :sync="true"
              color="#5685D8"
              id="motivo_obrigatorio"
              name="motivo_obrigatorio"
              v-model="motivo_obrigatorio"
            />
          </div>
          Motivo reagendamento obrigatório?
        </div>
        <div class="col-md-2 pl-0">
          <button
            class="btn btn-block btn-submit-tipo-compromisso btn-success btn-sm mt-4"
            data-style="zoom-in"
            type="submit"
          >
            {{ $t("Cadastrar") }}
            <i class="mdi mdi-content-save"/>
          </button>
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-12">
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />
        <b-table
          :fields="[
						{
							key: 'id',
							label: $t('ID'),
						},
						{
							key: 'descricao',
							label: $t('Descrição'),
						},
						{
							key: 'motivo_obrigatorio',
							label: $t('Motivo reagendamento obrigatório'),
						},
						{
							key: 'icone',
							label: $t('Ícone'),
						},
						{
							key: 'actions',
							label: '',
							class: 'text-right',
							thStyle: { width: '95px', minWidth: '95px' },
						},
					]"
          :items="tiposCompromissos"
          :responsive="true"
          striped
          hover
          show-empty
          small
          outlined
          stacked="md"
          table-class="mb-3"
        >
          <template v-slot:cell(id)="data">
            {{ data.item.id }}
          </template>
          <template v-slot:cell(descricao)="data">
            {{ data.item.descricao }}
          </template>
          <template v-slot:cell(icone)="data">
            <i :class="`mdi mdi-18px ${data.item.icone}`"/>
          </template>
          <template v-slot:cell(motivo_obrigatorio)="data">
            {{ data.item.motivo_obrigatorio ? "Sim" : "Não" }}
          </template>
          <template v-slot:cell()="data">
            <b-button
              @click="
                $bvModal.show('tipo-compromisso-edit-modal');
                item = { ... data.item }
              "
              :title="$t('Editar')"
              class="px-2 mb-0"
              size="xs"
              type="button"
              v-b-tooltip.hover
              variant="success"
            >
              <i class="mdi mdi-square-edit-outline" />
            </b-button>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
              />
              <h3 class="bold">{{ $t("No records found") }}</h3>
            </div>
          </template>
        </b-table>

        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                @change="getListTiposCompromissos"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }} {{ pagination.currentPage }}
              {{ $t("of") }}
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <TipoCompromissoModal :item="item" :atualizar-tipo-compromisso="(it) => atualizarTipoCompromisso(it)"/>
  </div>
</template>
<script>
import TipoCompromissoModal from "./modals/TipoCompromissoModal.vue";

export default {
  name: "TiposCompromissos",
  components: {
    TipoCompromissoModal
  },
  data() {
    return {
      tiposCompromissos: [],
      descricao: null,
      motivo_obrigatorio: false,
      icone: null,
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      item: "",
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },
  mounted() {
    this.getListTiposCompromissos();
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
        this.page = page;
        this.getListTiposCompromissos();
      }
    },

    getListTiposCompromissos() {
      this.loading = true;
      axios
        .post("api/dashboard/admin/list/tipos-compromissos", {
          page: this.page,
          perPage: this.perPage,
          search: this.search,
        })
        .then((response) => {
          this.tiposCompromissos = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getListTiposCompromissos();
          } else {
            this.loading = false;
          }
        });
    },

    async inserirTipoCompromisso() {
      let ladda = Ladda.create(document.querySelector(".btn-submit-tipo-compromisso"));
      ladda.start();
      this.loading = true;
      await axios
        .post("api/dashboard/admin/store/tipos-compromissos", {
          descricao: this.descricao,
          icone: this.icone,
          motivo_obrigatorio: this.motivo_obrigatorio
        })
        .then((response) => {
          if (response.status === 200) {
            this.getListTiposCompromissos();
            this.$snack.success({
              button: false,
              text: "Tipo de Compromisso cadastrado com sucesso!",
            });
            this.descricao = null;
          }
        });
      this.loading = false;
      ladda.stop();
    },

    async atualizarTipoCompromisso(it) {
      let ladda = Ladda.create(document.querySelector(".btn-submit-edit-tipo-compromisso"));
      ladda.start();
      this.loading = true;
      await axios
        .put(`api/dashboard/admin/update/tipos-compromissos/${it.id}`, {
          descricao: it.descricao,
          icone: it.icone,
          motivo_obrigatorio: it.motivo_obrigatorio
        })
        .then((response) => {
          if (response.status === 200) {
            this.getListTiposCompromissos();
            this.$snack.success({
              button: false,
              text: "Tipo de Compromisso atualizado com sucesso!",
            });

            this.$bvModal.hide("tipo-compromisso-edit-modal");
          }
        });
      this.loading = false;
      ladda.stop();
    },
  },
};
</script>
